import React from 'react';
import { Globe02 } from '@untitledui/icons';

import { Select } from '../../../common/@roma/src/components/base/select/select';
import { type LocaleOption } from '../../user/account/accountModal/localisation/localizationConstants';

type AuthLocaleSelectProps = {
    selectedLocale: string | null;
    localeOptions: LocaleOption[];
    onSelectLocale: (locale: string | null) => void;
    className?: string;
};

const AuthLocaleSelect: React.FC<AuthLocaleSelectProps> = ({
    selectedLocale,
    localeOptions,
    onSelectLocale,
    className,
}) => {
    if (!selectedLocale || !localeOptions.length) return null;

    const items = localeOptions.map(({ id, label }) => ({
        id,
        label,
    }));

    return (
        <div className={className || 'flex justify-center'}>
            <Select
                value={selectedLocale}
                onChange={(key) => onSelectLocale(key != null ? String(key) : null)}
                items={items}
                size="sm"
                leadingIcon={Globe02}
                className="w-[142px]"
            >
                {(item) => <Select.Item {...item} />}
            </Select>
        </div>
    );
};

export default AuthLocaleSelect;
